import React from 'react';
import { Button, Row, Col } from 'antd';
import {Price} from '../../../lib/Common';

const ProductItem = ({item, jpy, view, sale, limited, onSelect}) => (
  <div>
    <a className='list-tour mb-4' href={item.url}>
      {sale &&
      <img className='list-tour__label'
           src='/themes/Bootstrap4-alpha6/dev/images/icon/sale.svg'
           alt={`${item.name} - セール`}/>
      }
      {limited &&
      <img className='list-tour__label'
           src='/themes/Bootstrap4-alpha6/dev/images/icon/sale.svg'
           alt={`${item.name} - 期間限定`}/>
      }
      <Row type='flex' gutter={8}>
        <Col xs={6}>
          <img className='list-tour__img border-1 rounded mb-2' src={item.thumb} alt=''/>
        </Col>
        <Col xs={12}>
          {/*<div className='fs-xs text-primary'>{item.city_name}</div>*/}
          <h3 className='list-tour__title'>{item.name}</h3>
          {view == 'list' &&
            <p className='list-tour__desc'>{item.intro}</p>
          }
        </Col>
        <Col xs={6}>
          <div className='list-tour__option'>{item.jguide?'日本語ガイド':'英語ガイド'}</div>
          <div className='list-tour__price'><Price item={item} jpy={jpy}/></div>
          <Button onClick={onSelect}>見る</Button>
        </Col>
      </Row>
    </a>
  </div>
);

export default ProductItem;



// WEBPACK FOOTER //
// ./src/pages/travel/components/ProductItem.js